import { FunctionComponent } from 'react'
import styles from './suggestHeader.module.scss'
import DaycareSelector from '@/components/DaycareSelector/daycareSelector'
import Tabs from '@/components/_custom/Tabs/tabs'
import { useAuth } from '@/modules/context/AuthContext'
import { useTranslation } from 'react-i18next'
import Desktop from '@/modules/desktopMobile/desktop'
import SpinningSettingsIcon from '@/components/_custom/Buttons/SpinningSettingsIcon/SpinningSettingsIcon'

interface SuggestHeaderProps {
    switchTab: number
    setSwitchTab: (newTab: number) => void
    showAssMat: boolean
}

const SuggestHeader: FunctionComponent<SuggestHeaderProps> = ({
    switchTab,
    setSwitchTab,
    showAssMat
}: SuggestHeaderProps) => {
    const { t } = useTranslation()

    const { user } = useAuth()

    const TAB_LIST: string[] = showAssMat ? [t('family'), t('assMatShort'), t('staff')] : [t('family'), t('staff')]

    return (
        <div className={styles.HeaderRow}>
            {user && user?.daycares.length > 1 && (
                <div className={styles.MultipleSections}>
                    <DaycareSelector />
                </div>
            )}
            <div
                className={`${styles.TabsContainer} ${
                    user?.daycares.length === 1 && !user?.currentDaycareRights.canReadParamsDaycare
                        ? styles.TabsContainerAlone
                        : user?.daycares.length === 1 && user?.currentDaycareRights.canReadParamsDaycare
                          ? styles.TabsContainerWithParameters
                          : styles.TabsContainerWithParametersAndDaycares
                }`}
            >
                <Tabs value={switchTab} onChange={(_e, newValue) => setSwitchTab(newValue)} tabList={TAB_LIST} />
            </div>
            {user?.currentDaycareRights.canReadParamsDaycare && (
                <Desktop>
                    <SpinningSettingsIcon section='suggest' size={48} />
                </Desktop>
            )}
        </div>
    )
}

export default SuggestHeader
